import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-contact1-icon',
  templateUrl: './communication-contact1.component.html'
})
export class CommunicationContact1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
